import { render } from "./VmsSidebarCamerasTabGroupDialog.vue?vue&type=template&id=cf0456e0&ts=true"
import script from "./VmsSidebarCamerasTabGroupDialog.vue?vue&type=script&lang=ts"
export * from "./VmsSidebarCamerasTabGroupDialog.vue?vue&type=script&lang=ts"

import "./VmsSidebarCamerasTabGroupDialog.vue?vue&type=style&index=0&id=cf0456e0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__